import getIntl from 'Helpers/intl'
import { storeGet } from 'Helpers/localStorage'
import { logAppError } from 'Helpers/logger'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'
import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow
} from 'mailup-web-components'
import {
  deleteSource,
  getArrayOfListsByIdSource,
  getArrayOfSourcesByIdList,
  getCampaignsByIdSource,
  getListOfContents,
  getListOfSources,
  getListOfStatus,
  getTargetLists,
  getUserLists,
  setArrayOfListsByIdSource
} from 'Pages/SourcesList/recoil/actions/actions'
import {
  modalDeleteState,
  modalSharedListsState
} from 'Pages/SourcesList/recoil/state/modals'
import { moreResults, pageState } from 'Pages/SourcesList/recoil/state/page'

export const initPageCallback =
  ({ set, snapshot }) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      fetching: true,
      fetchingLoaded: false,
      loaded: false
    }))

    const { pageSize, pageNumber, orderBy, orderDescending } =
      await snapshot.getPromise(pageState)

    try {
      const idList = storeGet(STORE_KEY_ID_LIST)
      const idsSources = await getArrayOfSourcesByIdList(idList)

      const queryParams = {
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
        filterSourceIds: idsSources
      }

      if (idsSources !== null) {
        const { Items: items, TotalItems: totalItems } =
          await getListOfSources(queryParams)

        set(pageState, (prev) => ({
          ...prev,
          items: items || [],
          totalItems,
          isEmptyState: !totalItems,
          loaded: true
        }))
      } else {
        set(pageState, (prev) => ({
          ...prev,
          isEmptyState: true,
          loaded: true
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'ContentsSourcesList',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      fetching: false,
      fetchingLoaded: true,
      loaded: true
    }))
  }

export const fetchMoreResultsCallback =
  ({ set }) =>
  async (idSource) => {
    set(moreResults(idSource), (prev) => ({
      ...prev,
      moreLoading: true,
      moreLoaded: false
    }))

    try {
      const [
        { Items: moreLastContentUpdates },
        { TotalItems: moreContentsNumber },
        listsShared
      ] = await Promise.all([
        getListOfStatus(idSource),
        getListOfContents(idSource),
        getArrayOfListsByIdSource(idSource)
      ])

      const idList = storeGet(STORE_KEY_ID_LIST)

      set(moreResults(idSource), (prev) => ({
        ...prev,
        moreLastContentUpdates: moreLastContentUpdates[0],
        moreContentsNumber,
        moreShared: !listsShared.every((el) => el === idList),
        moreLoaded: true
      }))
    } catch (error) {
      logAppError({
        Component: 'ContentsSourcesList',
        Method: 'fetchMoreResultsCallback',
        appError: error
      })
      set(moreResults(idSource), {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(moreResults(idSource), (prev) => ({
      ...prev,
      moreLoading: false,
      moreLoaded: true
    }))
  }

export const pageChangeCallback =
  ({ snapshot, set }) =>
  async (pageNumber) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false
    }))

    const { pageSize, orderBy, orderDescending } =
      await snapshot.getPromise(pageState)

    try {
      const idList = storeGet(STORE_KEY_ID_LIST)
      const idsSources = await getArrayOfSourcesByIdList(idList)

      const queryParams = {
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
        filterSourceIds: idsSources
      }

      if (idsSources !== null) {
        const { Items: items, TotalItems: totalItems } =
          await getListOfSources(queryParams)

        set(pageState, (prev) => ({
          ...prev,
          items,
          totalItems,
          pageNumber,
          loaded: true
        }))
      } else {
        set(pageState, (prev) => ({
          ...prev,
          isEmptyState: true,
          loaded: true
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'ContentsSourcesList',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  }

export const pageSizeChangeCallback =
  ({ snapshot, set }) =>
  async (pageSize) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false
    }))

    const { orderBy, orderDescending } = await snapshot.getPromise(pageState)

    try {
      const idList = storeGet(STORE_KEY_ID_LIST)
      const idsSources = await getArrayOfSourcesByIdList(idList)

      const queryParams = {
        pageSize,
        pageNumber: 1,
        orderBy,
        orderDescending,
        filterSourceIds: idsSources
      }

      if (idsSources !== null) {
        const { Items: items, TotalItems: totalItems } =
          await getListOfSources(queryParams)

        set(pageState, (prev) => ({
          ...prev,
          items,
          totalItems,
          pageSize,
          loaded: true
        }))
      } else {
        set(pageState, (prev) => ({
          ...prev,
          isEmptyState: true,
          loaded: true
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'ContentsSourcesList',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  }

export const changeColumnsOrderCallback =
  ({ snapshot, set }) =>
  async (field) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false
    }))
    const { pageSize, orderDescending } = await snapshot.getPromise(pageState)

    set(pageState, (prev) => ({
      ...prev,
      orderBy: field,
      orderDescending: !orderDescending,
      pageNumber: 1
    }))

    try {
      const idList = storeGet(STORE_KEY_ID_LIST)
      const idsSources = await getArrayOfSourcesByIdList(idList)

      const queryParams = {
        pageSize,
        pageNumber: 1,
        orderBy: field,
        orderDescending: !orderDescending,
        filterSourceIds: idsSources
      }

      if (idsSources !== null) {
        const { Items: items, TotalItems: totalItems } =
          await getListOfSources(queryParams)

        set(pageState, (prev) => ({
          ...prev,
          items,
          totalItems,
          loaded: true
        }))
      } else {
        set(pageState, (prev) => ({
          ...prev,
          isEmptyState: true,
          loaded: true
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'ContentsSourcesList',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  }

export const deleteSourceCallback =
  ({ reset, set, snapshot }) =>
  async (idRow, onDeleteWarning) => {
    const modalParams = await snapshot.getPromise(modalDeleteState)
    set(pageState, (prev) => ({
      ...prev,
      fetching: true
    }))

    let res
    try {
      const [relatedCampaigns, userLists] = await Promise.all([
        getCampaignsByIdSource(modalParams.idRow),
        getUserLists()
      ])

      const idList = storeGet(STORE_KEY_ID_LIST)

      if (relatedCampaigns.TotalItems > 0) {
        onDeleteWarning(
          relatedCampaigns,
          userLists,
          idList,
          modalParams.sourceName
        )
      } else {
        res = await deleteSource(modalParams.idRow, onDeleteWarning)
        if (!res) {
          toastShow(
            getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
            TOAST_VARIANT_ERROR,
            'deleteSourceCallbackKO'
          )
        } else {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.ContentsSouces.DeletedSuccessfully'
            }),
            TOAST_VARIANT_SUCCESS,
            'deleteSourceCallbackOK'
          )
        }
      }

      reset(modalDeleteState)
    } catch (error) {
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      fetching: false
    }))
    return res
  }

export const modalSharedListsCallback =
  ({ set }) =>
  async (idRow) => {
    set(pageState, (prev) => ({
      ...prev,
      fetching: true
    }))

    try {
      const idList = storeGet(STORE_KEY_ID_LIST)
      const [lists, listsShared] = await Promise.all([
        getTargetLists(idList, idRow),
        getArrayOfListsByIdSource(idRow)
      ])
      const isSelectedAll = listsShared[0] === 0
      const listsSharedRequired = lists
        .filter((el) => el.disabled)
        .map((el) => el.value)

      set(modalSharedListsState, {
        show: true,
        idRow,
        lists,
        listsShared,
        copyToLists: isSelectedAll ? listsSharedRequired : listsShared,
        selectAll: isSelectedAll
      })
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      fetching: false
    }))
  }

export const modalSharedListsConfirmCallback =
  ({ set, snapshot, reset }) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      fetching: true
    }))
    const { idRow, selectAll, copyToLists } = await snapshot.getPromise(
      modalSharedListsState
    )

    try {
      const targetList = selectAll ? [0] : copyToLists
      await setArrayOfListsByIdSource(idRow, targetList)

      set(modalSharedListsState, (prev) => ({
        ...prev,
        show: false,
        saving: true
      }))
      setTimeout(() => reset(modalSharedListsState), 1500)

      toastShow(
        getIntl().formatMessage({
          id: 'Load.MailupCommon.OperationSucces'
        }),
        TOAST_VARIANT_SUCCESS
      )
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      fetching: false
    }))
  }

export const modalSharedListsCancelCallback =
  ({ set, reset }) =>
  async () => {
    set(modalSharedListsState, (prev) => ({
      ...prev,
      show: false
    }))
    setTimeout(() => reset(modalSharedListsState), 1500)
  }
